import * as React from 'react';

const Confirm = () => {
  return <>Confirm</>;
};

export default Confirm;
